import * as React from "react";
import OpQuotesHeadingMfDsk, { IOpQuotesHeadingMfDskProps } from "../partials/opQuotesHeadingMfDsk";
import OpQuotesHoldings from "../partials/opQuotesHoldings";
import OpMarketDepthList from "../partials/opMarketDepthList";
import "../../../../../assets/scss/components/toc/orderPlacement/opQuotes/opQuotesMob.scss";
import moment from "moment";
import { toINR } from "../../../../service/numberFormat";

export interface IOpQuotesMfMobProps {
	quoteData: any;
	quoteDataExtra: any;
	holdingData?: any;
}

const OpQuotesMfMob: React.FC<IOpQuotesMfMobProps> = props => {
	const [showHoldings, setShowHoldings] = React.useState(false);
	const [showMarketDepth, setShowMarketDepth] = React.useState(false);

	const quotesHeadingProps: IOpQuotesHeadingMfDskProps = {
		SchemeName: props.quoteData.SchemeName,
		nav: props.quoteData.nav,
		changeinnav: props.quoteData.changeinnav,
		changeinnavper: props.quoteData.changeinnavper,
		navdateformat: props.quoteData.navdateformat
	};

	return (
		<div className="quotes_cont mf">
			<OpQuotesHeadingMfDsk {...quotesHeadingProps} />

			<div className="quotes_cont_row m_2">
				<button className="blue_btn" onClick={() => setShowMarketDepth(true)}>
					Market Depth
				</button>

				{props.holdingData && (
					<button className="blue_btn" onClick={() => setShowHoldings(true)}>
						<i className="edel-icon-purse" /> {toINR(props.holdingData.units)} qty
					</button>
				)}
			</div>

			{showMarketDepth && (
				<>
					<div className="popup_overlay" onClick={() => setShowMarketDepth(false)} />
					<div className="popup">
						<div className="popup_header">
							<span>Market Depth</span>
							<button className="edel-icon-close" onClick={() => setShowMarketDepth(false)} />
						</div>
						<OpMarketDepthList
							data={[
								{ label: "AUM (in Crs.)", value: toINR(props.quoteDataExtra.AUM) },
								{ label: "MorningStar Rating", value: props.quoteDataExtra.Rating || "0" },
								{ label: "Benchmark Index", value: props.quoteDataExtra.Benchmark || "--" },
								{ label: "Category", value: props.quoteDataExtra.Category || "--" },
								{
									label: "Inception Date",
									value: props.quoteDataExtra.InceptionDate ? moment(props.quoteDataExtra.InceptionDate).format("DD MMM YYYY") : "--"
								},
								{ label: "Risk Category", value: props.quoteDataExtra.RiskCategory || "--" },
								{ label: "3Yr Returns (%)", value: props.quoteDataExtra.Year3 ? `${props.quoteDataExtra.Year3}%` : "--" }
							]}
						/>
					</div>
				</>
			)}

			{showHoldings && (
				<>
					<div className="popup_overlay" onClick={() => setShowHoldings(false)} />
					<div className="popup">
						<div className="popup_header">
							<span>Your Holdings</span>
							<button className="edel-icon-close" onClick={() => setShowHoldings(false)} />
						</div>
						<OpQuotesHoldings
							data={[
								{ label: "Current Value", value: `₹ ${toINR(+props.holdingData.units * +props.holdingData.nav)}` },
								{ label: "Units", value: toINR(props.holdingData.units) }
								// { label: "Unrealised G/L", value: "₹ 1,23,532.56 (12.34%)" }
							]}
							hldgOrPos="holding"
						/>
					</div>
				</>
			)}
		</div>
	);
};

export default OpQuotesMfMob;
